import {IEnvironment} from '../app/0-application/types'

export const environment: IEnvironment = {
  production: false,
  authServiceUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  // We need this to be consistent with regular borgo.
  domain: 'borgo-loan-fe-stage.internal.sparbankensyd.se',
  apiUrl: 'https://api-hypo-loan-be-test.internal.sparbankensyd.se/api',
  testMode: true
}
